<div class="modal-body">
<div class="row">
    <rask-input class="col-3" label="Titel" [ngModel]="data.titleLong" [readonly]="true"></rask-input>
    <rask-input class="col-2" label="Senast uppdaterad" [ngModel]="data.lastUpdated" [readonly]="true"></rask-input>
    <div class="col-2">
        <rask-label class="status-label" size="12">Status</rask-label>
        <rask-icon class="col-6" [text]="data.status" [icon]="getStatusIcon(data.status)"></rask-icon>
    </div>
</div>
<div class="row">
    <rask-textarea class="col-7" label="Meddelande" [ngModel]="data.message" [readonly]="true" [rows]="5"></rask-textarea>
</div>
</div>
<div class="modal-footer">
    <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Stäng</rask-button>
</div>
